import React from 'react';
import { Button, Form, Input } from 'antd';
import { Iconsvg } from '../../icon/icon';
import useLoading from '../../hooks/useLoading';
import { Login } from '../../servies/Login';
import useAuth from '../../hooks/useAuth';
import { makePersistable } from '../../utils/localstore';
import useDialogAlert from '../../hooks/useDialogAlert';
import { gatShopMe } from '../../servies/shop';
import icomlogin from '../../img/login-icon.png';
type Props = {};
const LOCAL_TOKEN_KEY = 'renegade';
const Index = (props: Props) => {
  const { isLoad, setLoad } = useLoading();
  const { error } = useDialogAlert();
  const [form] = Form.useForm();
  const { sync } = useAuth();
  const onFinish = async (values: any) => {
    setLoad(true);
    try {
      const loginResponse = await Login(values.username, values.password);
      console.log('loginResponse', loginResponse);
      if (loginResponse.status === 201) {
        setLoad(false);
        // success({ header: 'เข้าสู่ระบบสำเร็จ', sub: '' });
        let _res = await gatShopMe(loginResponse.data.token);
        let _dataLogin = {
          ...loginResponse.data,
          ..._res.data,
        };
        makePersistable(LOCAL_TOKEN_KEY, JSON.stringify(_dataLogin));

        sync(async () => {
          // navigate('/Home');
          setLoad(false);
        });
      } else {
        setLoad(false);
        error({
          header: 'ID ผู้ใช้งาน หรือรหัสผ่านไม่ถูกต้อง',
          sub: 'กรุณาลองใหม่อีกครั้ง',
        });
      }
      // makePersistable(LOCAL_TOKEN_KEY, loginResponse.data)
      //  sync(async () => {
      //   navigate("/Home")
      //     setLoad(false);
      //   });
    } catch (error) {
      onReset();
    }
    console.log('Success:', values, isLoad);
  };
  const onReset = () => {
    form.resetFields();
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  // if (isLoad) {
  //   return (
  //     <>
  //       <Spin />
  //     </>
  //   );
  // }
  return (
    <div
      style={{
        padding: '40px 70px',
        display: 'flex',
        flexDirection: 'column',
        gap: ' 70px ',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <img src={icomlogin} alt="login" width="100px" height="150px" />
      </div>
      <div>
        <Form
          name="basic"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          form={form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            label={<div className="labal-color">ID ผู้ใช้งาน</div>}
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
            className="input-form-border"
          >
            <Input
              prefix={<Iconsvg.IconUser />}
              placeholder="กรอก ID ผู้ใช้งาน"
              className="input-login"
            />
          </Form.Item>

          <Form.Item
            label={<div className="labal-color">รหัสผ่าน</div>}
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
            className="input-form-border"
          >
            <Input.Password
              className="input-login"
              prefix={<Iconsvg.IconPassword />}
              placeholder="กรอกรหัสผ่าน"
            />
          </Form.Item>

          <Form.Item style={{ textAlign: 'center' }}>
            <Button className="button-login-submit" htmlType="submit">
              เข้าสู่ระบบ
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Index;
